import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { portalActions } from "../../../store/portal-slice";
import whitelabelConfig from "@whitelabel-config";
import { getLocalStore, setLocalStore } from "helpers/localStoreSrv";
const CONST_ENUM = {
    "AUTH_COMPONENT_2FA": '2fa',
    "AUTH_REFERENCE_2FA": 'AUTH-2FA',
    "AUTH_COMPONENT_PII": 'pii',
    "AUTH_REFERENCE_PII": 'AUTH-PII',
    "AUTH_COMPONENT_ANONYMOUS": 'anonymous',
    "AUTH_REFERENCE_ANONYMOUS": 'AUTH-ANONYMOUS',
    "AUTH_COMPONENT_B2C":'b2c',
    "AUTH_REFERENCE_B2C": 'AUTH-B2C',
    "AUTH_ROUTE_PATH": '/auth',
}
export const useAuthProvider = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [authFlow, setAuthFlow] = useState(whitelabelConfig.authFlow)
    const micrositeSession = useSelector((state: any) => state.portal.micrositeSession);
    const portalAuthWizardConfig = useSelector((state: any) => state.portal.authWizard);
    const portalAuthSession = useSelector((state: any) => state.portal.authSession);
    const initAuth = (authMode: any = "DEFAULT") => {
        console.log(authFlow);
        const currAuthFlow = authFlow[authMode] ? authFlow[authMode] : authFlow["DEFAULT"]
        dispatch(portalActions.updateAuthWizard(currAuthFlow));
        console.log('initiating auth');
        console.log('initiating auth', authMode)

    }
    const identifyCurrentActionType = (authFlowConfig: any) => {
        if ('actionType' in authFlowConfig) return authFlowConfig.actionType;
        else return false;
    }
    const runAuthWizard = () => {
        const authFlowConfig = portalAuthWizardConfig;
        console.log(portalAuthWizardConfig);
        let currentActionType = identifyCurrentActionType(authFlowConfig);
        switch (currentActionType) {
            case 'AUTH':
                const authStep = {
                    step: portalAuthWizardConfig.actionFlow,
                    actionReference: portalAuthWizardConfig.actionFlow.actionReference
                }
                promptAuthStep(authStep)
                break;
            default:
            // code block
        }
    }
    const promptAuthStep = (authStep: any) => {
        console.log(authStep);
        switch (authStep.actionReference) {
            case CONST_ENUM.AUTH_REFERENCE_2FA:
                const tfaNavParams = { state: { authStep: authStep.step } }
                navigate(`${CONST_ENUM.AUTH_ROUTE_PATH}/${CONST_ENUM.AUTH_COMPONENT_2FA}`, tfaNavParams);
                break;
            case CONST_ENUM.AUTH_REFERENCE_PII:
                const piiNavParams = { state: { authStep: authStep.step } }
                navigate(`${CONST_ENUM.AUTH_ROUTE_PATH}/${CONST_ENUM.AUTH_COMPONENT_PII}`, piiNavParams);
                break;
            case CONST_ENUM.AUTH_REFERENCE_ANONYMOUS:
                const authAnonymousNavParams = { state: { authStep: authStep.step } }
                navigate(`${CONST_ENUM.AUTH_ROUTE_PATH}/${CONST_ENUM.AUTH_COMPONENT_ANONYMOUS}`, authAnonymousNavParams);
                break;
            case CONST_ENUM.AUTH_REFERENCE_B2C:
                const authb2cNavParams = { state: { authStep: authStep.step } }
                navigate(`${CONST_ENUM.AUTH_ROUTE_PATH}/${CONST_ENUM.AUTH_COMPONENT_B2C}`, authb2cNavParams);
                break;
            default:
            // code block
        }
    }
    const updateAuthSession = (authSession: any) => {
        console.log(authSession);
        dispatch(portalActions.updateAuthSession(authSession));

    }
    const updateAuthWizard = (authWizardCallback: any) => {
        console.log(authWizardCallback);
        if (authWizardCallback?.isAuthCompleted == true) {
            const authSession = {
                is_authenticated: true,
                auth_progress: 'COMPLETED'
            }
            console.log("micrositeSession.targetComponent", micrositeSession.targetComponent)
            dispatch(portalActions.updateAuthSession(authSession));
            dispatch(portalActions.updateAuthWizard({}));
            let landingModule = micrositeSession.targetComponent ? micrositeSession.targetComponent : (whitelabelConfig.uiSettings.landingModule ? whitelabelConfig.uiSettings.landingModule : '/')
            navigate(`/${landingModule}`)
        }
        else if (portalAuthWizardConfig &&  portalAuthWizardConfig.hasOwnProperty('actionType')) {
            dispatch(portalActions.updateAuthWizard(authWizardCallback));
        }
    }
    const isSessionAuthenticated = () => {
        return portalAuthSession.is_authenticated;
    }
    const restoreAuthSession = (authSession: any) => {
        console.log(authSession);
        dispatch(portalActions.updateAuthSession(authSession));
    }
    useEffect(() => {
        console.log('running authwiz');
        console.log(portalAuthWizardConfig);
        if (portalAuthWizardConfig && portalAuthWizardConfig.hasOwnProperty('actionType')) runAuthWizard();
    }, [portalAuthWizardConfig])
    useEffect(() => {
        console.log(portalAuthSession);
        if (portalAuthSession.auth_progress != 'NOT-STARTED') setLocalStore('PAS', portalAuthSession)
    }, [portalAuthSession])
    useEffect(() => {
        const prevPAS = getLocalStore('PAS');
        // if (prevPAS) restoreAuthSession(prevPAS)
    }, [])
    return { initAuth, isSessionAuthenticated, updateAuthSession, updateAuthWizard }
}